import React from 'react';
import I18n from '@/modules/i18n';
import { LmsIconKind } from '@/components/shared/Lms/types';
import gradeSyncUrl from '@/components/shared/gradeSyncUrl';
import LmsButton from './LmsButton';

interface OpenInGradeSyncProps {
  assignmentId: number;
  lmsKind: LmsIconKind | null;
}

const OpenInGradeSync = ({ assignmentId, lmsKind }: OpenInGradeSyncProps) => {
  const open = () => window.location.assign(gradeSyncUrl(assignmentId));

  return (
    <LmsButton handleClick={open} lmsKind={lmsKind}>
      <i className="fa fa-lock" /> {I18n.t('open_in_grade_sync')}
    </LmsButton>
  );
};

export default OpenInGradeSync;
